import { render } from "./infinityScroll.vue?vue&type=template&id=4aec5d43"
import script from "./infinityScroll.vue?vue&type=script&lang=js"
export * from "./infinityScroll.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/birchplace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__